/**
 * Przez ten plik przechodzą wszystkie połączenia z backendem
 * On też jest używany przez testy żeby stubować wyniki fetchów
 */

import {getEnvBool, getEnv} from "@/utilities/env";
import {isMatch, isString} from "lodash-es";

const apiUrl = `${getEnv('VITE_NFHOTEL_PROTOCOL')}://booking.${getEnv('VITE_NFHOTEL_HOST')}/api2/`;

export function isRequestExecuted(method: string, pathRegex: RegExp, requestObjectFilter: object | null = null) {
    if (!getEnvBool('DEV')) {
        return false;
    }
    for (const request of self.requestsExecuted) {
        if (request.method === method && pathRegex.test(request.path)) {
            if (requestObjectFilter) {
                if (!request.body || !isMatch(request.body, requestObjectFilter)) {
                    continue;
                }
            }
            return true;
        }
    }
    return false;
}

/**
 * Funkcja używana podczas testów do podmieniania wyników requestów
 */
export function stubApiResult(response: any, method: string, pathRegex: RegExp, requestObjectFilter: object | null = null) {
    if (getEnvBool('DEV')) {
        const _response: Response = <Response><unknown>{
            ok: true,
            status: 200,
            json() {
                return Promise.resolve(response)
            },
            text() {
                return Promise.resolve(response)
            },

            //null stubs
            arrayBuffer() {
                return Promise.resolve(undefined);
            }, blob() {
                return Promise.resolve(undefined);
            },
            body: undefined,
            bodyUsed: false,
            clone() {
                return null;
            },
            formData() {
                return Promise.resolve(undefined);
            },
            headers: undefined,
            redirected: false,
            statusText: "",
            type: undefined,
            url: "",
        }
        self.resultStubs.push({method, pathRegex, requestObjectFilter, response: _response});
    }
}

export function clearApiStubs() {
    self.resultStubs.length = 0;
    self.requestsExecuted.length = 0;
}

if (getEnvBool('DEV')) {
    self.stubApiResult = stubApiResult;
    self.clearApiStubs = clearApiStubs;
    self.isRequestExecuted = isRequestExecuted;
    if (!self.resultStubs) {
        self.resultStubs = [];
    }
    if (!self.requestsExecuted) {
        self.requestsExecuted = [];
    }
}

function getParentWindow(): typeof self|null {
    //@ts-ignore
    if (self.parent) {
        //@ts-ignore
        return  <typeof self>self.parent;
    }
    return null;
}

function getResultStub(method: string, path: string, body: object | string = {}, type = '') {
    if (!getEnvBool('DEV')) {
        return null;
    }
    let _resultStubs = self.resultStubs;
    try {
        const parentWindow = getParentWindow();
        if (parentWindow?.resultStubs) {
            _resultStubs = [..._resultStubs, ...parentWindow.resultStubs];
        }
    } catch (e) {
        console.error(e);
        //ignorujemy
    }
    if (method == 'GET') {
        for (const stub of _resultStubs) {
            if (stub.method === method && stub.pathRegex.test(path)) {
                return Promise.resolve(stub.response);
            }
        }
    } else if (method == 'POST') {
        let bodyObject: object;
        if (isString(body)) {
            bodyObject = JSON.parse(<string>body);
        } else {
            bodyObject = body;
        }
        for (const stub of _resultStubs) {
            if (stub.method === method && stub.pathRegex.test(path)) {
                if (stub.requestObjectFilter) {
                    if (!isMatch(bodyObject, stub.requestObjectFilter)) {
                        continue;
                    }
                }
                return Promise.resolve(stub.response);
            }
        }
    }
    return null;
}

export function getFromBookingApi(path: string): Promise<Response> {
    saveRequest('GET', path, null, null);
    const stubResult = getResultStub('GET', path);
    if (stubResult) {
        return stubResult;
    }
    return fetch(apiUrl + path, {
        method: 'GET'
    });
}

function saveRequest(method: string, path: string, body: object | string | null = null, type: string | null = null) {
    if (getEnvBool('DEV')) {
        let bodyObject: object|null;
        if (isString(body)) {
            bodyObject = JSON.parse(<string>body);
        } else {
            bodyObject = body;
        }
        const savedRequest = {
            method,
            path,
            body: bodyObject,
            contentType: type
        };
        self.requestsExecuted.push(savedRequest)
        try {
            const parentWindow = getParentWindow();
            if (parentWindow?.requestsExecuted) {
                parentWindow.requestsExecuted.push(savedRequest)
            }
        } catch (e) {
            console.error(e);
            //ignore
        }
    }
}

export function postToBookingApi(path: string, body: object | string, type = 'application/json'): Promise<Response> {
    saveRequest('POST', path, body, type);
    const stubResult = getResultStub('POST', path, body, type);
    if (stubResult) {
        return stubResult;
    }
    if (typeof body === 'object' && type == 'application/json') {
        body = JSON.stringify(body);
    }
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': type
        },
        body: <string>body,
    }
    return fetch(apiUrl + path, options);
}